module.exports = __webpack_public_path__ + "media/images/front/icons/roll_paper-9fe9242ae16b32571ded6c3a1e119672.png";